module.exports = __webpack_public_path__ + "images/btn_cv_column_bu_e313322d8232abdf3243e4efde0f7249.png";